import React, {useEffect, useRef} from 'react';
import {observer} from "mobx-react";
import {globalStore} from "stores";
import styled from 'styled-components'
import {hooks, hoc} from 'lib'

const Wrap = styled.div`
  position: absolute;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  border-radius: 4px;
  width: 150px;
  z-index: ${props => props.theme.zIndex.pagePopup};

  .item {
    position: relative;
    padding: 0 15px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    color: ${props => props.theme.color.grayLight};

    &:first-child {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    &:last-child {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    ul {
      position: absolute;
      left: 100%;
      top: 0;
      //transform: translateY(-50%);
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
      background-color: #fff;
      border-radius: 4px;
      width: 150px;
      display: none;

      li {

      }
    }

    &:hover {
      color: ${props => props.theme.color.gray};
      background-color: ${props => props.theme.color.grayLighter};

      ul {
        display: block;
      }
    }


  }

  &.sm {
    width: 120px;

    .item ul {
      width: 120px;
    }
  }

  &.left {
    margin-left: -150px;
  }

  &.left.sm {
    margin-left: -120px;
  }

  &.bottom {
  }
`

const Item = () => {

}


const Menu = ((props) => {

  let {
    children,
    className = '',
    onSelectItem,
    items,
    onClose
  } = props;

  let {
    x, y
  } = globalStore.position.position

  // let left = x
  // let top = y;

  let {width, height} = hooks.useScreenSize()
  // let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  // let scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
  //
  if (width - 70 < 150) {
    className += ' left'
  }


  // useEffect(() => {
  //
  //   const clickDoc =() => {
  //     console.log('clickDoc')
  //     onClose()
  //   }
  //
  //   document.querySelector('body').addEventListener('click', clickDoc)
  //   return () => {
  //     document.querySelector('body').removeEventListener('click', clickDoc)
  //   }
  // }, [])


  const _onSelectItem = (e) => {
    let {index, subindex} = e.currentTarget.dataset;

    // console.log('onSelectItem menu', index, subindex, e.currentTarget.dataset)

    let key = items[index].key

    if (items[index].children) {
      if (subindex) {
        let subKey = items[index].children[subindex].key;
        onSelectItem && onSelectItem(key, subKey)
        onClose()
      }
    } else {
      onSelectItem && onSelectItem(key)
      onClose()
    }


  }

  const _stop = (e) => {
  }

  const renderChildren = (index, subItems) => {
    if (subItems && subItems.length) {
      return <ul>
        {
          subItems.map((item, subIndex) => <li
            key={item.key}
            onClick={_onSelectItem}
            className={'item'}
            data-index={index}
            data-subindex={subIndex}
          >{item.text}</li>)
        }
      </ul>
    }
    return null
  }

  const _onClose = () => {
    onClose()
  }

  const wrapRef = useRef()
  hooks.useClickAway(wrapRef, _onClose)

  return (
    <Wrap
      ref={wrapRef}
      style={{left: (x + 4) + 'px', top: (y + 4) + 'px'}}
      className={className}
      onMouseLeave={_onClose}
      onClick={_stop}>
      {
        items.map((child, index) => {
          return <div className={'item'} key={child.key} data-index={index} onClick={_onSelectItem}>
            {child.text}
            {renderChildren(index, child.children)}
          </div>
        })
      }
    </Wrap>
  )

})

let close = () => {
}

Menu.show = (options) => {

  close()

  if (options.items.length > 0) {
    close = hoc.render(options, Menu);
  }
  return close
}

export default observer(Menu);
